import { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { usePageTitle } from '@hooks/usePageTitle';
import ContourBG from '@components/ContourBG';
import { FAQ_DATA } from '@data/faqData';

const FaqItem = ({ q, a, n, c }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: `1px solid ${c.border}` }}>
      <button onClick={() => setOpen((o) => !o)} aria-expanded={open}
        style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 0', textAlign: 'left', background: 'transparent', border: 'none', cursor: 'pointer', gap: 12 }}>
        <span style={{ display: 'flex', alignItems: 'baseline', gap: 14, minWidth: 0 }}>
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: c.mutedDim, flexShrink: 0, fontVariantNumeric: 'tabular-nums' }}>{String(n).padStart(2, '0')}</span>
          <span style={{ fontSize: 15.5, fontWeight: 600, color: c.head, lineHeight: 1.4 }}>{q}</span>
        </span>
        <ChevronDown size={16} color={c.muted} style={{ flexShrink: 0, transform: open ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 0.2s' }}/>
      </button>
      {open && <div style={{ paddingBottom: 20, paddingLeft: 25, fontSize: 14, color: c.muted, lineHeight: 1.75, maxWidth: 640 }}>{a}</div>}
    </div>
  );
};

const Faq = () => {
  usePageTitle('FAQ — Castle Atlas');

  const [isDark, setIsDark] = useState(() =>
    typeof window !== 'undefined' && document.documentElement.classList.contains('dark')
  );
  useEffect(() => {
    const obs = new MutationObserver(() =>
      setIsDark(document.documentElement.classList.contains('dark'))
    );
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    return () => obs.disconnect();
  }, []);

  const c = {
    pageBg: isDark ? '#0e0d0c' : '#faf9f7',
    border: isDark ? '#2d2825' : '#e8e4df',
    head: isDark ? '#fafaf9' : '#1c1917',
    muted: isDark ? '#a8a29e' : '#78716c',
    mutedDim: isDark ? '#57534e' : '#a8a29e',
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: c.pageBg }}>
      <div style={{ position: 'relative', overflow: 'hidden', borderBottom: `1px solid ${c.border}` }}>
        <ContourBG isDark={isDark}/>
        <div style={{ maxWidth: 720, margin: '0 auto', padding: '72px 24px 48px', position: 'relative', zIndex: 2 }}>
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, fontWeight: 600, color: '#ea580c', letterSpacing: '0.14em' }}>OPEN QUESTIONS</span>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(2rem,5vw,2.8rem)', fontWeight: 900, letterSpacing: '-0.03em', color: c.head, margin: '14px 0 0', lineHeight: 1.08 }}>
            The hard questions
          </h1>
        </div>
      </div>
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '40px 24px 96px' }}>
        <div style={{ borderTop: `1px solid ${c.border}` }}>
          {FAQ_DATA.map((f, i) => <FaqItem key={f.id} q={f.q} a={f.a} n={i + 1} c={c}/>)}
        </div>
      </div>
    </div>
  );
};

export default Faq;
